"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSignOutCallbackRequestForPagesRouter = void 0;
const adapter_core_1 = require("aws-amplify/adapter-core");
const constant_1 = require("../constant");
const utils_1 = require("../utils");
const handleSignOutCallbackRequestForPagesRouter = async ({ request, response, handlerInput, userPoolClientId, oAuthConfig, setCookieOptions, origin, }) => {
    const { [constant_1.IS_SIGNING_OUT_COOKIE_NAME]: isSigningOut, [constant_1.IS_SIGNING_OUT_REDIRECTING_COOKIE_NAME]: isSigningOutRedirecting, } = (0, utils_1.getCookieValuesFromNextApiRequest)(request, [
        constant_1.IS_SIGNING_OUT_COOKIE_NAME,
        constant_1.IS_SIGNING_OUT_REDIRECTING_COOKIE_NAME,
    ]);
    if (!isSigningOut) {
        response.status(400).end();
        return;
    }
    // When Cognito /logout endpoint redirects back, response has code 302, the browsers (Safari and Firefox)
    // assume the incoming request is a cross-site request and block the cookies.
    // To workaround this issue, we send an intermediate page with 200 response. This page will redirect
    // to the /sign-out-callback (this handler) again, since it's the same-site request, the cookies will be
    // sent back to the server.
    if (isSigningOutRedirecting) {
        (0, utils_1.appendSetCookieHeadersToNextApiResponse)(response, 
        // remove the IS_SIGNING_OUT_REDIRECTING_COOKIE_NAME cookie to the next request to this
        // handler can proceed.
        (0, utils_1.createTokenRemoveCookies)([constant_1.IS_SIGNING_OUT_REDIRECTING_COOKIE_NAME]), (0, utils_1.createAuthFlowProofCookiesRemoveOptions)(setCookieOptions));
        response
            .appendHeader('Content-Type', 'text/html')
            .status(200)
            .send((0, utils_1.createRedirectionIntermediary)({
            redirectTo: (0, utils_1.resolveRedirectSignOutUrl)(origin, oAuthConfig),
        }));
        return;
    }
    const lastAuthUserCookieName = `${adapter_core_1.AUTH_KEY_PREFIX}.${userPoolClientId}.LastAuthUser`;
    const { [lastAuthUserCookieName]: username } = (0, utils_1.getCookieValuesFromNextApiRequest)(request, [lastAuthUserCookieName]);
    if (!username) {
        response.redirect(302, (0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignOutComplete));
        return;
    }
    const authCookiesKeys = (0, adapter_core_1.createKeysForAuthStorage)(adapter_core_1.AUTH_KEY_PREFIX, `${userPoolClientId}.${username}`);
    const { [authCookiesKeys.refreshToken]: refreshToken } = (0, utils_1.getCookieValuesFromNextApiRequest)(request, [
        authCookiesKeys.refreshToken,
    ]);
    if (!refreshToken) {
        response.redirect(302, (0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignOutComplete));
        return;
    }
    const result = await (0, utils_1.revokeAuthNTokens)({
        refreshToken,
        userPoolClientId,
        endpointDomain: oAuthConfig.domain,
    });
    if (result.error) {
        response.status(500).send(result.error);
        return;
    }
    (0, utils_1.appendSetCookieHeadersToNextApiResponse)(response, [
        ...(0, utils_1.createTokenRemoveCookies)([
            authCookiesKeys.accessToken,
            authCookiesKeys.idToken,
            authCookiesKeys.refreshToken,
            lastAuthUserCookieName,
            constant_1.IS_SIGNING_OUT_COOKIE_NAME,
        ]),
    ], (0, utils_1.createTokenCookiesRemoveOptions)(setCookieOptions));
    response.redirect(302, (0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignOutComplete));
};
exports.handleSignOutCallbackRequestForPagesRouter = handleSignOutCallbackRequestForPagesRouter;
